import React, { useContext } from "react";
import Form from "react-bootstrap/Form";
import { QuizContext } from "../../App";

const FormTeamEditName = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;

  return (
    <Form style={{ marginBottom: "20px" }}>
      <Form.Label
        style={{
          fontWeight: "600"
        }}
      >
        Редактировать название команды
      </Form.Label>

      <Form.Control
        type="text"
        data-bs-theme={theme}
        style={{
          border: theme === "dark"
            ? "1px solid #77797c"
            : "1px solid #212529",
          textAlign: "center"
        }}
        value={quizContext.state.teamName}
        onChange={(e) => quizContext.dispatch({
          type: "editTeamName",
          payload: e.target.value
        })}
      />
    </Form>
  )
}

export default FormTeamEditName